import React, { useState, useEffect } from 'react';
import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Offcanvas from "react-bootstrap/Offcanvas";
import "../css/Custom.css";
import { Modal, Button } from "react-bootstrap";
import { Link } from "react-router";
import config from "../../../config/config";
import Cookies from "js-cookie";
import { useAccount, useDisconnect } from 'wagmi';
let walletAddress = Cookies.get("walletAddress")

const DashboardHeader = () => {
  const { isConnected, address, chainId, isDisconnected, chain } = useAccount();

  if (!walletAddress) {
    window.location.href = `${config.baseUrl}`
  }

  useEffect(() => {
    if (isConnected && address) {
      Cookies.set('walletAddress', address);
      if (walletAddress != address) {
        window.location.reload()
      }
    }
  }, [address, isConnected]);

  const [show, setShow] = useState(false);
  return (
    <>
      {["xl"].map((expand) => (
        <Navbar
          key={expand}
          expand={expand}
          className=" navbar-background"
          style={{ height: 85 }}
        >
          <Container fluid className="py-1">
            <div className="d-flex d-xl-none w-100">
              <Navbar.Brand
                className=" w-100  d-flex justify-content-center align-items-center "
              >
                <Link to={`${config.baseUrl}`} className="">
                  <img
                    src="assets/images/logo/logo.png"
                    style={{ width: 200, height: 53, marginLeft: 25 }}
                    className="object-fit-contain"
                    alt=""
                  />
                </Link>
              </Navbar.Brand>
              <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`} />
            </div>
            <Navbar.Offcanvas
              className="offcanvas-body01"
              id={`offcanvasNavbar-expand-${expand} `}
              aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
              placement="end"
            >
              <Offcanvas.Header className="navbar-background" closeButton>
                <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
                  <Link to={`${config.baseUrl}`}>
                    {" "}
                    <img
                      src="assets/images/logo/logo.png"
                      style={{ width: 224, height: 53 }}
                      alt=""
                    />
                  </Link>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body className="offcanvas-body01 justify-content-end">
                <div className="d-flex flex-row flex-wrap gap-3 lg-sp align-self-stretch">
                  <Button className="text-black">
                    {walletAddress
                      ? walletAddress.toString().substring(0, 4) +
                      '....' +
                      walletAddress
                        .toString()
                        .substring(walletAddress.length - 4, walletAddress.length)
                      : 'Connect Wallet'}
                  </Button>

                </div>
              </Offcanvas.Body>
            </Navbar.Offcanvas>
          </Container>
        </Navbar>
      ))}

      <Modal show={show} size="lg" centered backdropClassName="custom-backdrop">
        <Modal.Body closeButton>
          <div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default DashboardHeader;
